import ReactGA from 'react-ga4';
import { getStoredAnalyticsUserData, resolveAnalyticsUserType, shouldCollectAnalytics } from './analytics-collection.util';

let isGAInitialized = false;

export const initializeGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId) {
    console.warn('Google Analytics measurement ID is not configured.');
    return;
  }

  if (!shouldCollectAnalytics()) {
    return;
  }

  if (isGAInitialized) {
    return;
  }

  ReactGA.initialize(measurementId, { gtagOptions: { send_page_view: false } });
  isGAInitialized = true;
  ReactGA.gtag('config', measurementId, { send_page_view: false });
  const { email: userEmail, country, location } = getStoredAnalyticsUserData();
  const userCountry = country || location;
  const appUserType = resolveAnalyticsUserType(userEmail);
  const appUserCountry = userCountry || process.env.REACT_APP_DEFAULT_COUNTRY || 'unknown';

  ReactGA.gtag('set', 'user_properties', {
    app_user_type: appUserType,
    app_user_country: appUserCountry,
  });
};
